__turbopack_context__.v({
  "label": "FilterChip-module-scss-module__i_IjsW__label",
});
